import { action, makeObservable, observable } from 'mobx';
import { useEffect } from 'react';
import { FragranceModeration } from '~/api/api.declaration';
import { ApiService } from '~/service/service.api';
import { UIService } from '~/service/service.ui';
import { FragranceModerationDto } from '~/shared/dto/admin/fragrance.dto';
import { FragranceId } from '~/shared/dto/id';
import { Model } from '~/shared/service/service.base';
import { Async } from '~/shared/tools/async';
import { FragranceModerationDialog } from '~/view/dialog/dialog.fragrance.moderation';

@Model()
export class FragranceModerationModel {
	readonly async = new Async();

	@observable fragranceId = 0 as FragranceId;
	@observable data?: FragranceModeration = undefined;
	@observable.ref reloadCallback?: () => void = undefined;

	constructor(
		private ui: UIService,
		private api: ApiService,
	) {
		makeObservable(this);
	}

	use = () => {
		useEffect(() => this.reset(), []);

		return { open: this.ui.dialog === FragranceModerationDialog };
	};

	getOne = async () => {
		if (!this.fragranceId) return;
		return this.async.exec(async () => {
			const f = await this.api.fragranceGetOne(this.fragranceId).then(resp => resp.data);
			if (f) this.setData(f.moderation);
			return f.moderation;
		});
	};

	@action.bound setData = (data: FragranceModeration | undefined) => {
		this.data = data;
	};

	@action.bound showDialog = (fragranceId: FragranceId, reloadCallback: () => void) => {
		this.fragranceId = fragranceId;
		this.reloadCallback = reloadCallback;
		this.ui.showDialog(FragranceModerationDialog);
	};

	@action.bound reset = () => {
		this.data = undefined;
		this.fragranceId = 0 as FragranceId;
		this.reloadCallback = undefined;
	};

	save = async (data: FragranceModerationDto) => {
		if (!this.fragranceId) return;
		return this.async.call(async () => {
			await this.api.fragranceModerationSave(this.fragranceId, data);
			return () => {
				this.ui.hideDialog();
				this.ui.notify('Fragrance moderation saved', 'success');
				if (this.reloadCallback) this.reloadCallback();
			};
		});
	};
}
